module.exports = __webpack_public_path__ + "img/schedule20260922_1.0bf59ac8.jpg";